import React from 'react'
import { Container } from 'typescript-ioc/es5'
import { ConfigProvider } from 'antd'
import { AppState } from '../../stores/app'
import { AccountService, AppService } from '../../services'
import { getClassNames } from '../../_utils/classnames'
import { PageHeader } from '@pushly/aqe/lib/components'
import { AiView } from '../../components/domain-ai-settings/constants'
import { SettingsLayout } from '../settings/settings-layout'

export class Domain extends React.Component<any> {
    protected appState: AppState
    protected appService: AppService
    protected accountService: AccountService

    protected disposeObservers: any[] = []

    public constructor(props: any) {
        super(props)

        this.appState = Container.get(AppState)
        this.appService = Container.get(AppService)
        this.accountService = Container.get(AccountService)
    }

    public render() {
        return (
            <div className={getClassNames('page', 'single-domain')}>
                <div className={getClassNames('page-wrapper')}>
                    <PageHeader
                        title="Settings"
                        append={<span>ID: {this.requestedDomainId}</span>}
                        onTitleSet={this.appService.customizeTabTitle}
                    />

                    <ConfigProvider
                        theme={{
                            components: {
                                Form: {
                                    itemMarginBottom: 0,
                                    labelColor: 'var(--ant-color-secondary)',
                                },
                            },
                        }}
                    >
                        <SettingsLayout
                            hash={this.props.location.hash}
                            context={{
                                domainId: this.requestedDomainId,
                                domain: this.appState.currentDomain,
                                currentUser: this.appState.currentUser,
                                onAiViewChange: this.setCurrentAiView,
                            }}
                            onNavigate={this.setCurrentTabKey}
                        />
                    </ConfigProvider>
                </div>
            </div>
        )
    }

    protected get requestedDomainId(): number {
        return parseInt(this.props.match.params.domainId, 10)
    }

    protected setCurrentTabKey = (key: string): void => {
        this.appService.route(`${this.props.location.pathname}#${key}`)
    }

    protected setCurrentAiView = (view: AiView): void => {
        this.appService.route(`${this.props.location.pathname}#ai/${view}`)
    }
}
